import { render } from "./Verification.vue?vue&type=template&id=7f7cb094&scoped=true"
import script from "./Verification.vue?vue&type=script&lang=js"
export * from "./Verification.vue?vue&type=script&lang=js"

import "./Verification.vue?vue&type=style&index=0&id=7f7cb094&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f7cb094"]])

export default __exports__